












































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AddOrUpdateCartItem } from '@/models/Cart/Cart';
import { CheckoutStore } from '@/store/checkoutstate';
import { Spinner } from 'spin.js';
import { Option } from '@/models/Configurator';

@Component
export default class ConfigBuyButton extends Vue {
    @Prop() selectedConfigOptions!: Array<Option>;
    @Prop({ default: '' }) redirectUrl!: string;
    @Prop({ default: true }) showQuantityField!: boolean;
    @Prop({ default: true }) showPrice!: boolean;
    @Prop({ default: '' }) deliveryInfo!: string;
    @Prop({ default: '' }) currency!: string;
    @Prop({ default: '' }) warrantyYears!: string;
    @Prop({ default: () => [] }) errors!: Array<string>;
    public initQuantity: number;
    protected spinner: Spinner;
    private toggleError: boolean = false;
    public websiteId = (window as any).__litium.websiteId;
    
    constructor() {
        super();
        this.initQuantity = 1;
        this.spinner = new Spinner({ scale: 0.5, left: '90%', color: '#fff' });
    }

    get quantity(): number {
        return this.initQuantity;
    }
    set quantity(newValue: number) {
        if (!newValue) this.initQuantity = 1;
        else this.initQuantity = parseInt(newValue.toString().replace(/[^\d]/g, ''));
    }

    get totalPrice(): number {
        return (
            this.selectedOptions.reduce((prevVal: number, opt: Option) => {
                return prevVal + opt.price * opt.quantity;
            }, 0) * this.quantity
        );
    }

    get totalCampaignPrice(): number {
        return (
            this.selectedOptions.reduce((prevVal: number, opt: Option) => {
                if (opt.campaignPrice && typeof opt.campaignPrice !== 'undefined')
                    return prevVal + opt.campaignPrice * opt.quantity;
                else return prevVal + opt.price * opt.quantity;
            }, 0) * this.quantity
        );
    }

    get totalPriceDiff(): number {
        return this.totalCampaignPrice !== 0 ? this.totalPrice - this.totalCampaignPrice : 0;
    }

    get selectedOptions(): Array<Option> {
        return typeof this.selectedConfigOptions === 'string'
            ? JSON.parse(this.selectedConfigOptions)
            : this.selectedConfigOptions;
    }

    public addToCart(): void {
        this.spinner.spin(this.$el.querySelector('.buy-button') as HTMLElement);
        let productsToCartSum: Array<Option> = [];
        for (let i = 0; i < this.quantity; i++) {
            productsToCartSum = productsToCartSum.concat(this.selectedOptions);
        }
        //  console.log(productsToCartSum);
        const payload: Array<AddOrUpdateCartItem> = productsToCartSum.map((opt: Option, key: number) => {
            return {
                articleNumber: opt.id,
                quantity: opt.quantity,
                comment: typeof opt.comment !== 'undefined' ? opt.comment : '',
                type: opt.type
            } as AddOrUpdateCartItem;
        });

        const header = <HTMLElement>document.querySelector('#header-navigation');

        if (header && !header.classList.contains('show')) {
            const classList = header.classList;
            if (classList.contains('hide')) {
                classList.remove('hide');
            }
            if (classList.contains('bright')) {
                classList.remove('bright');
            }
            if (classList.contains('dark')) {
                classList.remove('dark');
            }
            if (!classList.contains('show')) {
                classList.add('show');
            }
            if (!classList.contains('backdrop')) {
                classList.add('backdrop');
            }
        }
        CheckoutStore.addListState(payload).then(() => {
            // this.quantity = 1;
            this.spinner.stop();
            this.$root.$emit('show-message');
            this.$root.$emit('show-complement');
        });

        if (this.redirectUrl !== '') {
            window.location.href = this.redirectUrl;
        }
    }

    public decrease() {
        if (this.initQuantity > 1) {
            this.initQuantity -= 1;
        } else {
            this.initQuantity = 1;
        }
    }

    public increase(): void {
        this.initQuantity += 1;
    }

    private restrictKey(e: KeyboardEvent) {
        if (e.key >= '1' && e.key <= '9') return true;
        else e.preventDefault();
    }
}
